"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOnChangeParticleSizeHandler = exports.createOnChangeOpacityHandler = exports.createOnChangeSizeHandler = exports.createOnChangeColorHandler = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const colors_1 = require("./colors");
function createOnChangeColorHandler({ bridge, growthManager, opacity, particleSize, size, setSelectedColor, }) {
    return (value) => {
        const { r, g, b } = (0, colors_1.hexToRgbComponents)(value);
        const rgbColorArray = [r, g, b];
        const rgbColorString = `${r},${g},${b}`;
        bridge === null || bridge === void 0 ? void 0 : bridge.toolUpdateGrowth({ color: rgbColorString });
        bridge === null || bridge === void 0 ? void 0 : bridge.toolkitOptionsAction({
            optionType: 4,
            color: rgbColorArray,
            type: bridge_schema_1.ToolType.Growth,
        });
        setSelectedColor(rgbColorString);
        growthManager === null || growthManager === void 0 ? void 0 : growthManager.updateGrowthOptions({
            color: rgbColorString,
            opacity: opacity,
            particleSize: particleSize,
            size: size,
        });
    };
}
exports.createOnChangeColorHandler = createOnChangeColorHandler;
function createOnChangeSizeHandler({ bridge, growthManager, color, opacity, particleSize, setSelectedSize, }) {
    return (value) => {
        bridge === null || bridge === void 0 ? void 0 : bridge.toolUpdateGrowth({ size: value });
        bridge === null || bridge === void 0 ? void 0 : bridge.toolkitOptionsAction({
            optionType: 1,
            size: 4 - value,
            type: bridge_schema_1.ToolType.Growth,
        });
        setSelectedSize(value);
        growthManager === null || growthManager === void 0 ? void 0 : growthManager.updateGrowthOptions({
            color: color,
            opacity: opacity,
            particleSize: particleSize,
            size: value,
        });
    };
}
exports.createOnChangeSizeHandler = createOnChangeSizeHandler;
function createOnChangeOpacityHandler({ bridge, growthManager, color, particleSize, size, }) {
    return (value) => {
        bridge === null || bridge === void 0 ? void 0 : bridge.toolUpdateGrowth({ opacity: value });
        bridge === null || bridge === void 0 ? void 0 : bridge.toolkitOptionsAction({
            optionType: 3,
            val: (1 - value) * 100,
            type: bridge_schema_1.ToolType.Growth,
        });
        growthManager === null || growthManager === void 0 ? void 0 : growthManager.updateGrowthOptions({
            color: color,
            opacity: value,
            particleSize: particleSize,
            size: size,
        });
    };
}
exports.createOnChangeOpacityHandler = createOnChangeOpacityHandler;
function createOnChangeParticleSizeHandler({ bridge, growthManager, color, opacity, size, setSelectedParticleSize, }) {
    return (value) => {
        bridge === null || bridge === void 0 ? void 0 : bridge.toolUpdateGrowth({ particleSize: value });
        bridge === null || bridge === void 0 ? void 0 : bridge.toolkitOptionsAction({
            optionType: 2,
            val: value,
            type: bridge_schema_1.ToolType.Growth,
        });
        setSelectedParticleSize(value);
        growthManager === null || growthManager === void 0 ? void 0 : growthManager.updateGrowthOptions({
            color: color,
            opacity: opacity,
            particleSize: value,
            size: size,
        });
    };
}
exports.createOnChangeParticleSizeHandler = createOnChangeParticleSizeHandler;
